import { Box } from '@chakra-ui/react';

type CompletedCheckBadgeProps = {
  // Accessible label — set when the badge is meaningful (e.g. "Automation
  // completed"); omit to leave it decorative.
  label?: string;
};

/**
 * The "completed" tick: a filled `success-200` circle with a white check.
 * Shared by the bulk-operation queue (move / send / reject candidates) and the
 * automation underway popup so their completion ticks are pixel-identical.
 */
export const CompletedCheckBadge = ({ label }: CompletedCheckBadgeProps) => (
  <Box
    w="18px"
    h="18px"
    borderRadius="full"
    bg="success-200"
    display="flex"
    alignItems="center"
    justifyContent="center"
    flexShrink={0}
    role={label ? 'img' : undefined}
    aria-label={label}
  >
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M1 4L3.5 6.5L9 1"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Box>
);
